import * as Yup from 'yup'

export const validationSchema = (t) =>
  Yup.object().shape({
    factory: Yup.object().nullable().required(t('form.required')),
  })
